import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CheckPreview } from "@/components/CheckPreview";
import { HeroSection } from "@/components/landing/HeroSection";
import { InformesPricingSection } from "@/components/landing/InformesPricingSection";
import { FaqSection } from "@/components/landing/FaqSection";
import { BenchmarkSection, StepsSection, RolesSection, CtaSection } from "@/components/landing/LandingSections";
import { useAuth } from "@/context/AuthContext";
import { Suspense } from "react";
import { lazyWithReload } from "@/lib/lazyWithReload";
import { Flag } from "@/context/SiteFlagsContext";
import { ProximamenteSection } from "@/components/landing/ProximamenteSection";

// La tabla comparativa se carga diferida (debajo del fold) para no engordar el bundle inicial.
const ComparisonSection = lazyWithReload(() =>
  import("@/components/ComparisonSection").then((m) => ({ default: m.ComparisonSection })));
const InformesComparadorSection = lazyWithReload(() =>
  import("@/components/pending-services/InformesComparadorSection").then((m) => ({ default: m.InformesComparadorSection })));

export default function Landing() {
  const { login, user } = useAuth();

  return (
    <div className="bg-[#F8F9FA]">
      <Navbar transparent />
      <HeroSection login={login} user={user} />
      <CheckPreview />
      <BenchmarkSection />
      <StepsSection />
      <InformesPricingSection login={login} user={user} />
      {/* servicio pendiente — reactivar vía flag en Cerebro (compararPrecios) */}
      <Suspense fallback={null}>
        <Flag name="compararPrecios"><InformesComparadorSection /></Flag>
      </Suspense>
      <RolesSection />
      <ProximamenteSection />
      <Suspense fallback={null}>
        <ComparisonSection />
      </Suspense>
      <FaqSection />
      <CtaSection login={login} user={user} />
      <Footer />
    </div>
  );
}
